import { Navigate, useLocation } from "react-router-dom"

export default function RedirectWithSearch({ to }: { to: string }) {
  const { search } = useLocation()

  return <Navigate replace to={`${to}${search}`} />
}
